import axios from 'axios';

// Define your backend URL (replace with your actual backend API)

// Middleware function to check if the user has the related organization
export async function checkIfUserHasRelatedOrg  (userId, currentOrgId) {
   
  try {
    // Make an API call to get user data
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
        userId: JSON.parse(localStorage.getItem('user')).userId.S
    });
    
    if (response.status ===  200) {
      const user = response.data.user;
      

      if(user.relatedOrgs.L?.find((e)=> e?.M.org_id?.S ===  JSON.parse(localStorage.getItem('organization')).orgId.S)){
           return true
      }else{
        return false
      }

      // Compare the related_org_id and current_org_id
      //const hasRelatedOrg = user.related_org_id ===  currentOrgId;

     // return hasRelatedOrg; // Return true if related_org_id matches currentOrgId, else false
    } else {
      // Handle error if the response is not successful
      console.error('Failed to fetch user data:', response.statusText);
      return false;
    }
  } catch (error) {
    console.error('Error fetching user data:', error);
    return false; // In case of any error, return false
  }
};




